<template>
  <modal ref='attachFileMyRelaticoModal'>
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('header.attach_from_relatico.header') }}</h5>
    </template>

    <template #body>
      <div class='modal-body modal-scroll'>
        <form @submit.prevent='showAllResults()' class="search-container">
          <input
              :class="['search-bar', 'ui-autocomplete-input', 'form-control']"
              :placeholder="$t('header.search')"
              @input="debounceRecordSearch"
              autocomplete="off"
              id="records-search"
              name="q"
              required="required"
              type="text"
              v-click-outside="showAllResults"
              v-model="recordSearch">
          <button type="submit" class="btn btn-neutral">
            <i class="fas fa-search"></i>
          </button>
        </form>

        <ul class="short-search-results" v-if="showSearch">
          <li :key='result._id' @click.prevent="addSearchRecord(result._id)" v-for="result in searchData.slice(0, 5)" v-bind:class="{'selected-file': isRecordSelected(result._id)}">
            <strong v-if="result.highlight && result.highlight.content.length !== 0" v-html="result.highlight.content[0]"></strong>
            <strong v-else>{{result._source.content || result._source.source_type}} </strong>
          <li class="see-all" v-if="searchDataMeta.total != 0">
            <p>{{ $t('header.see_all_data') }} ({{ searchDataMeta.total }})</p>
          </li>
        </ul>


        <ul>
          <li v-if="showResults" v-for="(result, index) in searchData" :key='index' v-bind:class="{'selected-file': isRecordSelected(result._id)}" @click.prevent="addSearchRecord(result._id)">
            <strong v-if="result.highlight && result.highlight.content.length !== 0" v-html="result.highlight.content[0]"></strong>
            <strong v-else>{{result._source.content || result._source.source_type}} </strong>
          </li>
        </ul>

        <p v-if="searchDataMeta.total == 0" class="top-space">{{ $t('header.attach_from_relatico.no_results') }}</p>
        <button @click.prevent="submitAttach()" class="btn btn-primary float-right top-space">
          {{ $t('header.attach_from_relatico.submit') }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import _modal from './_modal'

export default {
  components: {
    'modal': _modal
  },
  data() {
    return {
      selectedRecords: [],
      recordSearch: null,
      showSearch: false
    }
  },
  computed: {
    searchData() {
      return this.lists.searchResults || []
    },
    searchDataMeta() {
      return this.listStore.meta.searchResults || {}
    },
    showResults() {
      if(this.recordSearch)
        return !this.showSearch && this.recordSearch.length >= 3 && this.searchDataMeta.total != 0
      return false
    }
  },
  methods: {
    open() {
      this.selectedRecords = []
      this.recordSearch = null
      this.showSearch = false
      this.$refs.attachFileMyRelaticoModal.open()
    },
    addSearchRecord(record_id) {
      if (this.isRecordSelected(record_id)){
        this.removeFromSelectedRecords(record_id)
      } else {
        this.store.getRecord(record_id).then(()=>{
          if(this.state.record)
            this.selectedRecords.push(this.state.record)
        })
      }
    },
    isRecordSelected(record_id) {
      return this.selectedRecords.findIndex(f => f.id === parseInt(record_id)) != -1
    },
    removeFromSelectedRecords(record_id){
      const index = this.selectedRecords.findIndex(f => f.id === parseInt(record_id))
      if (index > -1) {
        this.selectedRecords.splice(index, 1)
      }
    },
    showAllResults() {
      this.showSearch = false
    },
    debounceRecordSearch() {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        if (this.recordSearch.length >= 3) {
          this.listStore.searchViaEs({q: this.recordSearch, source_type: "records", from: 0})
          this.showSearch = true
        }
      }, 150)
    },
    submitAttach() {
      this.$refs.attachFileMyRelaticoModal.close()
      this.$emit("complete", this.selectedRecords);
      this.store.sendMetrics({name: 'add_file_attachments_from_my_relatico', params: this.$route.params, path: this.$route.fullPath})
      this.selectedRecords = []
      this.recordSearch = null
    }
  }
}
</script>
<style lang="sass" scoped>
  .selected-file
    background: #ACD5ED
  .search-container
    display: flex
    margin-bottom: 20px
    .btn-neutral
      padding: 7px 15px
      background: #efefef
  .search-bar
    width: 90%
  .short-search-results, ul
    list-style: none
    padding: 0
    margin: 0
    max-height: 300px
    overflow-y: auto
    li
      font-size: 15px
      font-weight: 400
      cursor: pointer
      color: #686868
      padding: 5px
      margin-bottom: 5px
      &:hover
        background: #EDEDED
      &.see-all
        background: #EDEDED
        text-align: center
        color: #686868
        display: block
        padding: 10px 0
        p
          margin: 0

  .modal-scroll
    max-height: calc(100vh - 210px)
    overflow-y: auto
  .top-space
    padding-top: 10px
</style>
